











































































































































import { AppointmentApi } from '@/api/appointments';
import { ClientAccountsApi } from '@/api/client-accounts';
import { AppointmentOutcomeProductRequest } from '@/api/requests/appointments/appointment-outcome-product-request';
import { AppointmentProductPaymentDetailsRequest } from '@/api/requests/appointments/appointment-product-payment-details-request';
import { UpdateAppointmentOutcomeRequest } from '@/api/requests/appointments/update-appointment-outcome-request';
import appointmentOutcomeDetails from '@/components/appointments/appointment-outcome-details.vue';
import appointmentOutcomeInstructedProducts from '@/components/appointments/appointment-outcome-instructed-products.vue';
import appointmentOutcomeNotInstructedProducts from '@/components/appointments/appointment-outcome-not-instructed-products.vue';
import appointmentOutcomeNotes from '@/components/appointments/appointment-outcome-notes.vue';
import appointmentOutcomeProductDetails from '@/components/appointments/appointment-outcome-product-details.vue';
import appointmentOutcomeTypeSelect from '@/components/appointments/appointment-outcome-type-select.vue';
import bookAppointmentDialog from '@/components/appointments/book-appointment-dialog.vue';
import loading from '@/components/loading.vue';
import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { AppointmentOutcomeProduct, createAppointmentOutcomeProduct } from '@/shared/appointments/appointment-outcome-product';
import { AppointmentProductPaymentDetails } from '@/shared/appointments/appointment-product-payment-details';
import { ClientAccount } from '@/shared/clients/client-account';
import { InstructionType } from '@/shared/instruction-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { formatDate } from '@/shared/utilities/date-utilities';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const appointmentApi = new AppointmentApi();
const clientApi = new ClientAccountsApi();

@Component({
    components: {
        appointmentOutcomeDetails,
        appointmentOutcomeInstructedProducts,
        appointmentOutcomeNotInstructedProducts,
        appointmentOutcomeNotes,
        appointmentOutcomeProductDetails,
        appointmentOutcomeTypeSelect,
        bookAppointmentDialog,
        loading,
    },
})
export default class EditAppointmentOutcomeDialog extends Vue {
    @Prop({ required: true }) public appointment!: Appointment;
    @Prop({ required: true }) public visible!: boolean;

    @typesModule.Getter('appointmentTypes') private appointmentTypes!: Array<AppointmentType>;
    @typesModule.Getter('appointmentOutcomeTypes') private appointmentOutcomeTypes!: Array<AppointmentOutcomeType>;
    @typesModule.Getter('appointmentPaymentStatusTypes') private appointmentPaymentStatusTypes!: Array<AppointmentPaymentStatusType>;
    @typesModule.Getter('appointmentProductTypes') private appointmentProductTypes!: Array<AppointmentProductType>;

    private isVisible: boolean = this.visible;
    private isLoading: boolean = true;
    private isSaving: boolean = false;
    private currentTab: number = 0;
    private isOutcomeTypeValid: boolean = true;
    private isNotInstructedProductsValid: boolean = true;
    private isOutcomeDetailsValid: boolean = true;
    private isProductDetailsValid: boolean = true;
    private isNotesValid: boolean = true;

    private appointmentOutcome: AppointmentOutcome = { ...this.appointment.outcome! };
    private appointmentProducts: Array<AppointmentOutcomeProduct & { errors: boolean }> = new Array<AppointmentOutcomeProduct & { errors: boolean }>();

    private showBookAppointmentDialog: boolean = false;
    private appointmentClient: ClientAccount | null = null;
    private signingDate: string | Date | null = null;

    public get size(): string {
        return this.showProducts ? 'xl' : 'lg';
    }

    private get showProducts(): boolean {
        if (this.selectedAppointmentType == null || this.selectedAppointmentOutcomeType == null) {
            return false;
        }

        return this.selectedAppointmentType.isInitialAppointment && this.selectedAppointmentOutcomeType.isSat;
    }

    private get selectedAppointmentType(): AppointmentType | null {
        return this.appointment.appointmentTypeId == null ? null : this.appointmentTypes.find((type) => type.id === this.appointment.appointmentTypeId)!;
    }

    private get selectedAppointmentOutcomeType(): AppointmentOutcomeType | null {
        return this.appointmentOutcome.outcomeTypeId == null ? null : this.appointmentOutcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId)!;
    }

    private get productsToInstruct(): Array<AppointmentOutcomeProduct & { errors: boolean }> {
        if (!this.appointmentProducts.length) {
            return [];
        }

        return this.appointmentProducts.filter((product) => product.instructionType !== InstructionType.NotInstructed);
    }

    private get updateAppointmentOutcomeRequest(): UpdateAppointmentOutcomeRequest {
        const products: Array<AppointmentOutcomeProductRequest> = new Array<AppointmentOutcomeProductRequest>();

        const productsToInclude = this.appointmentProducts.length
            ? this.appointmentProducts.filter((product) => this.appointment.outcome!.products.some((p) => p.productTypeId === product.productTypeId) || product.instructionType !== InstructionType.NotInstructed)
            : [];

        for (const product of productsToInclude) {
            const paymentDetails: Array<AppointmentProductPaymentDetailsRequest> = new Array<AppointmentProductPaymentDetailsRequest>();

            for (const payment of product.paymentDetails) {
                paymentDetails.push({ ...payment, paymentStatusId: payment.paymentStatusId! });
            }

            products.push({ ...product, paymentDetails });
        }

        return { ...this.appointmentOutcome, products, outcomeTypeId: this.appointmentOutcome.outcomeTypeId!, version: this.appointmentOutcome.version!, paymentDetails: null };
    }

    private get isSigningAppointmentRequired(): boolean {
        if (!this.appointmentProducts.length) {
            return false;
        }

        this.signingDate = null;

        for (const product of this.appointmentProducts.filter((p) => p.instructionType === InstructionType.Instructed && p.paymentDetails.length)) {
            const paymentStatus = this.appointmentPaymentStatusTypes.find((type) => type.id === product.paymentDetails[0].paymentStatusId!);

            if (paymentStatus == null || !paymentStatus.isSigningBooked) {
                continue;
            }

            if (product.paymentDetails[0].signingDate == null || (this.signingDate != null && product.paymentDetails[0].signingDate > this.signingDate)) {
                continue;
            }

            const originalProduct = this.appointment.outcome!.products.find((p) => p.productTypeId === product.productTypeId);

            if (originalProduct == null || !originalProduct.paymentDetails.length || originalProduct.paymentDetails[0].signingDate !== product.paymentDetails[0].signingDate) {
                this.signingDate = product.paymentDetails[0].signingDate;
            }
        }

        return this.signingDate != null;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.$validator.errors.clear();
        this.isVisible = visible;
    }

    @Watch('appointmentOutcome', { deep: true })
    private async onAppointmentOutcomeChanged(): Promise<void> {
        await this.isValid();
    }

    @Watch('appointmentProducts', { deep: true })
    private async onAppointmentProductsChanged(): Promise<void> {
        await this.isValid();
    }

    @Watch('appointmentOutcome.outcomeTypeId')
    private onOutcomeTypeChanged(): void {
        this.clearAppointmentOutcome();

        if (this.showProducts) {
            this.createProducts();
            return;
        }

        this.clearProducts();
    }

    private appointmentProductTypeDescription(product: AppointmentOutcomeProduct): string {
        const appointmentProductType = this.appointmentProductTypes.find((type) => type.id === product.productTypeId);
        return appointmentProductType == null ? '' : appointmentProductType.value;
    }

    private appointmentInstructionTypeDescription(product: AppointmentOutcomeProduct): string {
        switch (product.instructionType) {
            case InstructionType.NotInstructed:
                return 'Not Instructed';

            case InstructionType.CoolingOff:
                return '14 Day Cooling Off Period';

            case InstructionType.ConsideringOptions:
                return 'Considering Options';

            case InstructionType.Instructed:
                return 'Instructed';

            default:
                return '';
        }
    }

    private appointmentPaymentStatusTypeDescription(product: AppointmentOutcomeProduct): string {
        if (!product.paymentDetails.length) {
            return '';
        }

        if (product.paymentDetails.length > 1) {
            return 'Part Payment';
        }

        const appointmentPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.id === product.paymentDetails[0].paymentStatusId);
        return appointmentPaymentStatusType == null ? 'Unknown' : appointmentPaymentStatusType.value;
    }

    private async isValid(): Promise<boolean> {
        this.isOutcomeTypeValid = await (this.$refs.outcomeType as Vue).$validator.validateAll('outcome-type');
        this.isOutcomeDetailsValid = await (this.$refs.outcomeDetails as Vue).$validator.validateAll('outcome-details');

        if (!this.showProducts) {
            return this.isOutcomeTypeValid && this.isOutcomeDetailsValid;
        }

        this.isNotInstructedProductsValid = await (this.$refs.notInstructedProducts as Vue).$validator.validateAll('not-instructed-products');
        this.isNotesValid = await (this.$refs.outcomeNotes as Vue).$validator.validateAll('outcome-notes');

        this.isProductDetailsValid = true;

        for (let index = 0; index < this.productsToInstruct.length; index++) {
            // @ts-ignore
            if (!(await this.$refs.productsToInstruct[index].validateProduct())) {
                this.isProductDetailsValid = false;
            }
        }

        return this.isOutcomeTypeValid && this.isOutcomeDetailsValid && this.isNotInstructedProductsValid && this.isNotesValid && this.isProductDetailsValid;
    }

    private async onSaveAsync(): Promise<void> {
        if (!(await this.isValid())) {
            return;
        }

        this.isSaving = true;

        try {
            await appointmentApi.updateAppointmentOutcomeAsync(this.appointment.id!, this.appointment.outcome!.id!, this.updateAppointmentOutcomeRequest);

            if (this.isSigningAppointmentRequired) {
                this.appointmentClient = await clientApi.getClientAccountByIdAsync(this.appointment.clients[0].id!);

                if (this.appointmentClient == null) {
                    this.$emit('ok', { ...this.appointmentOutcome });
                } else {
                    this.showBookAppointmentDialog = true;
                }
            } else {
                this.$emit('ok', { ...this.appointmentOutcome });
            }
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not update appointment outcome, please try again.', type: 'is-danger' });
            }
        }

        this.isSaving = false;
    }

    private onCancel(): void {
        this.showBookAppointmentDialog = false;
        this.$emit('cancel');
    }

    private onAppointmentBooked(): void {
        this.$snackbar.open({ message: `Appointment successfully booked.`, type: 'is-success' });
        this.$emit('ok', { ...this.appointmentOutcome });
    }

    private onAppointmentCancel(): void {
        this.showBookAppointmentDialog = false;
        this.$emit('ok', { ...this.appointmentOutcome });
    }

    private onProductChanged(product: { productTypeId: string, errors: boolean }): void {
        const appointmentProduct = this.appointmentProducts!.find((p) => p.productTypeId === product.productTypeId);

        if (appointmentProduct == null) {
            return;
        }

        appointmentProduct.errors = product.errors;
    }

    private clearAppointmentOutcome(): void {
        this.appointmentOutcome.instructionType = null;
        this.appointmentOutcome.cancellationTypeId = null;
        this.appointmentOutcome.noInstructionTypeId = null;
        this.appointmentOutcome.noInstructionNotes = null;
        this.appointmentOutcome.estimatedEstateValue = null;
        this.appointmentOutcome.executorTypeId = null;
        this.appointmentOutcome.callbackDate = null;
        this.appointmentOutcome.notes = null;

        this.clearProducts();
    }

    private createProducts(): void {
        this.appointmentProducts = new Array<AppointmentOutcomeProduct & { errors: boolean }>();

        for (const appointmentProductType of this.appointmentProductTypes) {
            this.appointmentProducts.push({ ...createAppointmentOutcomeProduct(appointmentProductType.id!), paymentStatusId: null, errors: false });
        }
    }

    private populateProducts(): void {
        this.createProducts();

        if (this.appointment.outcome!.products == null || !this.appointment.outcome!.products.length) {
            return;
        }

        for (const product of this.appointment.outcome!.products) {
            if (!this.appointmentProducts!.some((p) => p.productTypeId === product.productTypeId)) {
                continue;
            }

            const paymentDetails: Array<AppointmentProductPaymentDetails> = new Array<AppointmentProductPaymentDetails>();

            for (const payment of product.paymentDetails) {
                paymentDetails.push({
                    ...payment,
                    signingDate: formatDate(payment.signingDate),
                    bankedDate: formatDate(payment.bankedDate),
                    clearedDate: formatDate(payment.clearedDate),
                    debtorDate: formatDate(payment.debtorDate),
                    noLongerProceedingDate: formatDate(payment.noLongerProceedingDate),
                    writtenOffDate: formatDate(payment.writtenOffDate),
                });
            }

            const appointmentProduct: AppointmentOutcomeProduct & { errors: boolean } = { ...product, paymentDetails, instructedDate: formatDate(product.instructedDate), errors: false };

            if (product.paymentDetails.length) {
                const partPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.isPartPayment);
                appointmentProduct.paymentStatusId = product.paymentDetails.length > 1 ? partPaymentStatusType!.id! : product.paymentDetails[0].paymentStatusId;
            }

            const index = this.appointmentProducts!.findIndex((p) => p.productTypeId === product.productTypeId);

            if (index > -1) {
                this.appointmentProducts!.splice(index, 1, appointmentProduct);
            }
        }
    }

    private clearProducts(): void {
        this.appointmentProducts = [];
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        await Promise.all([
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        if (this.showProducts) {
            this.populateProducts();
        }

        this.isLoading = false;
    }
}
